// Step-design theme helpers shared by acquire-flows (runtime rendering) and
// boa-settings (flow configurator).
//
// There are three themes:
//   v1 — "Classic"  (legacy two-column promo layout)
//   v2 — "Modern (Images Allowed)"  (renders a hero image when one is set)
//   v3 — "Modern (Images Disabled)"  (same modern layout as v2, but hero
//        images are suppressed on every step except `start` and `success`)
//
// v2 and v3 share the same layout components; v3 only differs in that it
// behaves as if no hero image were set on the in-between steps. The two
// helpers below are the single source of truth for those two facts.

export type StepDesignTheme = "v1" | "v2" | "v3";

// Steps that keep their hero image even under v3.
const IMAGE_STEP_TYPES = new Set(["start", "success"]);

// v2 and v3 both use the "modern" layout (no left-hand promo column).
export const isModernTheme = (theme?: StepDesignTheme): boolean =>
  theme === "v2" || theme === "v3";

// Under v3 the hero image is hidden everywhere except start/success — both at
// runtime (treat the step as imageless) and in the configurator (hide the
// image upload field). `stepType` is the open StepType string set, not the
// theme union, so it stays loosely typed.
export const shouldHideHeroImage = (
  theme?: StepDesignTheme,
  stepType?: string
): boolean => theme === "v3" && !IMAGE_STEP_TYPES.has(stepType ?? "");
